import script from "./FAQS.vue?vue&type=script&lang=ts&setup=true"
export * from "./FAQS.vue?vue&type=script&lang=ts&setup=true"

import "./FAQS.vue?vue&type=style&index=0&id=c3d1891a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3d1891a"]])

export default __exports__